import { render, staticRenderFns } from "./VFileUpload.vue?vue&type=template&id=a2b5189e&scoped=true"
import script from "./VFileUpload.vue?vue&type=script&lang=js"
export * from "./VFileUpload.vue?vue&type=script&lang=js"
import style0 from "./VFileUpload.vue?vue&type=style&index=0&id=a2b5189e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b5189e",
  null
  
)

export default component.exports